import { compile } from 'vega-lite'
import vegaDelegate from './vegaDelegate'

export default Object.assign({
  compileVegaLite: compile
}, vegaDelegate)



// WEBPACK FOOTER //
// ./src/components/delegate/vegaLiteDelegate.js